<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="`${unit.unitName} - 单词学习`"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    @close="handleClose"
    class="unit-learning-dialog"
  >
    <!-- 对话框头部控制 -->
    <!-- <div class="dialog-header" slot="title">
      <div class="header-info">
        <i :class="modeIcon"></i>
        <span>{{ dialogTitle }}</span>
        <el-tag size="small" :type="modeType">{{ modeText }}</el-tag>
      </div>
      <div class="header-controls">
        <el-button
          @click="toggleBackgroundMusic"
          :type="backgroundMusicPlaying ? 'primary' : 'default'"
          size="mini"
          icon="el-icon-headset"
        >
          {{ backgroundMusicPlaying ? "音乐已开" : "背景音乐" }}
        </el-button>
        <el-button @click="closeDialog" size="mini" icon="el-icon-close">
          关闭
        </el-button>
      </div>
    </div> -->

    <div class="dialog-content">
      <!-- 学习进度 -->
      <div class="learning-progress">
        <div class="progress-info">
          <span class="current-phase">{{ getPhaseText() }}</span>
          <span class="words-count">{{ currentWordIndex + 1 }} / {{ totalWords }} 个单词</span>
        </div>
        <el-progress 
          :percentage="progressPercentage" 
          :stroke-width="8"
          :show-text="false"
        ></el-progress>
      </div>

      <!-- 第一阶段开始页面 -->
      <div class="phase-start" v-if="currentPhase === 'phase1-start'">
        <div class="start-content">
          <h2>第一阶段：英文→中文</h2>
          <p>看到英文单词，回忆中文意思</p>
          <p>点击"记住"或"没记住"来标记你的掌握程度</p>
          <el-button type="primary" size="large" @click="startPhase1">
            开始学习
          </el-button>
        </div>
      </div>

      <!-- 第一阶段：英文→中文 -->
      <div class="phase-content" v-if="currentPhase === 'phase1'">
        <div class="word-card">
          <div class="word-header">
            <span class="phase-title">第一阶段：英文→中文</span>
          </div>
          
          <div class="word-content">
             <div class="phase-word-top">
              <!-- 图片区域 - 固定在左侧红框位置 -->
              <div class="phase-word-image" v-if="currentWord && currentWord.imageUrl">
                <img 
                  :src="getImageUrl(currentWord.imageUrl, 1)" 
                  :alt="currentWord.word || currentWord.english_word"
                  class="phase-word-img"
                  @error="handleImageError"
                  @load="handleImageLoad"
                />
              </div>
              
              <div class="word-main">
                <h3 class="english-word">{{ currentWord.englishWord || currentWord.english_word }}</h3>
                <div class="word-phonetic">
                  <span v-if="currentWord.phoneticEn || currentWord.phonetic_en" class="phonetic-item">英[{{ currentWord.phoneticEn || currentWord.phonetic_en }}]</span>
                  <span v-if="currentWord.phoneticUs || currentWord.phonetic_us" class="phonetic-item">美[{{ currentWord.phoneticUs || currentWord.phonetic_us }}]</span>
                </div>
              </div>
            </div>
            
            <div class="word-actions">
              <el-button 
                type="success" 
                size="large" 
                @click="markAsKnown"
                icon="el-icon-check"
              >
                记住
              </el-button>
              <el-button 
                type="warning" 
                size="large" 
                @click="markAsUnknown"
                icon="el-icon-close"
              >
                没记住
              </el-button>
              <el-button 
                type="info" 
                size="small" 
                @click="playPronunciation"
                icon="el-icon-video-play"
              >
                发音
              </el-button>
            </div>
            
            <div class="word-meaning" v-if="showMeaning">
              <p class="chinese-meaning">{{ currentWord.chineseMeaning || currentWord.chinese_meaning }}</p>
              <p class="example-sentence" v-if="currentWord.exampleSentence || currentWord.example_sentence">
                {{ currentWord.exampleSentence || currentWord.example_sentence }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二阶段开始页面 -->
      <div class="phase-start" v-if="currentPhase === 'phase2-start'">
        <div class="start-content">
          <h2>第二阶段：中文→英文</h2>
          <p>看到中文释义，回忆英文单词</p>
          <p>点击"记住"或"没记住"来标记你的掌握程度</p>
          <el-button type="primary" size="large" @click="startPhase2">
            开始学习
          </el-button>
        </div>
      </div>

      <!-- 第二阶段：中文→英文 -->
      <div class="phase-content" v-if="currentPhase === 'phase2'">
        <div class="word-card">
          <div class="word-header">
            <span class="phase-title">第二阶段：中文→英文</span>
          </div>
          
          <div class="word-content">
            <!-- <div class="phase-word-top"> -->
              <!-- 图片区域 - 固定在左侧红框位置 -->
              <!-- <div class="phase-word-image" v-if="currentWord.imageUrl">
                <img 
                  :src="getImageUrl(currentWord.imageUrl)" 
                  :alt="currentWord.word || currentWord.english_word"
                  class="phase-word-img"
                  @error="handleImageError"
                  @load="handleImageLoad"
                />
              </div> -->

              <div class="word-main">
                <h3 class="chinese-meaning">{{ currentWord.chineseMeaning || currentWord.chinese_meaning }}</h3>
                <div class="word-phonetic">
                  <span v-if="currentWord.phonetic_en" class="phase-phonetic-item">英[{{ currentWord.phonetic_en }}]</span>
                  <span v-if="currentWord.phonetic_us" class="phase-phonetic-item">美[{{ currentWord.phonetic_us }}]</span>
                </div>
              </div>
              
            <!-- </div> -->
            
            <div class="word-actions">
              <el-button 
                type="success" 
                size="large" 
                @click="markAsKnown"
                icon="el-icon-check"
              >
                记住
              </el-button>
              <el-button 
                type="warning" 
                size="large" 
                @click="markAsUnknown"
                icon="el-icon-close"
              >
                没记住
              </el-button>
              <el-button 
                type="info" 
                size="small" 
                @click="playPronunciation"
                icon="el-icon-video-play"
              >
                发音
              </el-button>
            </div>
            
            <div class="word-meaning" v-if="showMeaning">
              <p class="english-word">{{ currentWord.englishWord || currentWord.english_word }}</p>
              <p class="example-sentence" v-if="currentWord.exampleSentence || currentWord.example_sentence">
                {{ currentWord.exampleSentence || currentWord.example_sentence }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三阶段开始页面 -->
      <div class="phase-start" v-if="currentPhase === 'phase3-start'">
        <div class="start-content">
          <h2>第三阶段：拼写测试</h2>
          <p>看到中文释义，输入英文单词</p>
          <p>必须完成所有单词的拼写测试，不能跳过</p>
          <el-button type="primary" size="large" @click="startPhase3">
            开始测试
          </el-button>
        </div>
      </div>

      <!-- 第三阶段：拼写测试 -->
      <div class="phase-content" v-if="currentPhase === 'phase3'">
        <div class="word-card">
          <div class="word-header">
            <span class="phase-title">第三阶段：拼写测试</span>
          </div>
          
          <div class="word-content">
            <div class="word-main">
              <h3 class="chinese-meaning">{{ currentWord.chineseMeaning || currentWord.chinese_meaning }}</h3>
              <div class="word-phonetic">
                <span v-if="currentWord.phonetic_en" class="phase-phonetic-item">英[{{ currentWord.phonetic_en }}]</span>
                <span v-if="currentWord.phonetic_us" class="phase-phonetic-item">美[{{ currentWord.phonetic_us }}]</span>
              </div>
            </div>
            
            <div class="spelling-input">
              <el-input
                v-model="userInput"
                placeholder="请输入英文单词"
                size="large"
                @keyup.enter="checkSpelling"
                @keydown.enter.native="checkSpelling"
                :disabled="showAnswer"
              ></el-input>
              <el-button 
                type="primary" 
                size="large" 
                @click="checkSpelling"
                :disabled="!userInput.trim() || showAnswer"
              >
                检查
              </el-button>
            </div>
            
            <div class="word-actions">
              <el-button 
                type="info" 
                size="small" 
                @click="playPronunciation"
                icon="el-icon-video-play"
              >
                发音
              </el-button>
            </div>
            
            <div class="word-meaning" v-if="showAnswer">
              <p class="english-word" :class="{ 'correct': isCorrect, 'incorrect': !isCorrect }">
                {{ currentWord.englishWord || currentWord.english_word }}
              </p>
              <p class="example-sentence" v-if="currentWord.example_sentence">
                {{ currentWord.exampleSentence || currentWord.example_sentence }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 学习总结 -->
      <div class="learning-summary" v-if="currentPhase === 'summary'">
        <div class="summary-header">
          <h3>学习总结</h3>
          <p>单元学习完成</p>
        </div>
        
        <div class="summary-stats">
          <div class="stat-item">
            <span class="stat-label">单词总数</span>
            <span class="stat-value">{{ totalWords }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">认识单词</span>
            <span class="stat-value known">{{ knownWords.length }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">不认识单词</span>
            <span class="stat-value unknown">{{ unknownWords.length }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">掌握率</span>
            <span class="stat-value" :class="{ 'excellent': masteryRate >= 90, 'good': masteryRate >= 80 && masteryRate < 90, 'poor': masteryRate < 60 }">{{ masteryRate }}%</span>
          </div>
        </div>
        
        <div class="learning-quality" v-if="unknownWords.length > 0">
          <div class="quality-warning">
            <i class="el-icon-warning"></i>
            <span>有 {{ unknownWords.length }} 个单词没记住，会影响学习效果和成绩！</span>
          </div>
        </div>
        
        <div class="summary-actions">
          <el-button 
            type="success" 
            @click="finishLearning"
            size="large"
          >
            完成学习
          </el-button>
          <el-button 
            v-if="unknownWords.length > 0"
            type="warning" 
            @click="reviewUnknownWords"
            size="large"
          >
            重新学习没记住的单词 ({{ unknownWords.length }}个)
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { CourseAPI } from "@/api/course";

export default {
  name: "UnitLearningDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    unit: {
      type: Object,
      default: () => ({
        id: null,
        unitName: "未知单元"
      })
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentPhase: 'phase1-start', // phase1-start, phase1, phase2-start, phase2, phase3-start, phase3, summary
      currentWordIndex: 0,
      totalWords: 0,
      originalWordCount: 0, // 原始单词数量
      words: [], // 所有单词
      currentWord: {},
      showMeaning: false,
      userInput: '',
      showAnswer: false,
      isCorrect: false,
      isRemembered: false, // 当前单词是否被记住
      
      // 学习结果统计
      phase1Results: [], // 第一阶段结果
      phase2Results: [], // 第二阶段结果
      phase3Results: [], // 第三阶段结果
      knownWords: [],
      unknownWords: [],
      
      // 防止重复调用的标志
      isReviewingUnknownWords: false,
      
      startTime: null,
      studyTime: 0
    };
  },
  computed: {
    progressPercentage() {
      if (this.totalWords === 0) return 0;
      return Math.round(((this.currentWordIndex + 1) / this.totalWords) * 100);
    },
    masteryRate() {
      if (this.totalWords === 0) return 0;
      return Math.round((this.knownWords.length / this.totalWords) * 100);
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.initLearning();
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);
    }
  },
  methods: {
    // 初始化学习
    async initLearning() {
      this.currentPhase = 'phase1-start';
      this.currentWordIndex = 0;
      this.startTime = Date.now();
      await this.loadWords();

      // 自动播放背景音乐
      this.playBackgroundMusic();
    },

    // 开始第一阶段
    startPhase1() {
      this.currentPhase = 'phase1';
      this.currentWordIndex = 0;
      this.currentWord = this.words[0];
      

      // 自动播放两遍读音
      this.autoPlayWordTwice();
    },

    // 开始第二阶段
    startPhase2() {
      this.currentPhase = 'phase2';
      this.currentWordIndex = 0;
      this.currentWord = this.words[0];

      // 自动播放两遍读音
      this.autoPlayWordTwice();
    },

    // 开始第三阶段
    startPhase3() {
      this.currentPhase = 'phase3';
      this.currentWordIndex = 0;
      this.currentWord = this.words[0];

      // 自动播放两遍读音
      this.autoPlayWordTwice();
    },

    // 加载单词
    async loadWords() {
      try {
        const response = await CourseAPI.getUnitWords(this.unit.id, 1, 100);
        
        if (response && response.success) {
          const data = response.data;
          this.words = data.words || [];
          this.totalWords = this.words.length;
          this.originalWordCount = this.words.length; // 记录原始单词数量
          
          if (this.totalWords > 0) {
            this.currentWord = this.words[0];
            // 预加载所有单词图片
            this.preloadImages(this.words).then(results => {
              const success = results.filter(r => r.success).length;
              const fail = results.length - success;
              console.log(`[UnitLearningDialog] 单元单词图片预加载完成: 成功${success}, 失败${fail}`);
            });
          }


   
          
          // 初始化结果数组
          this.phase1Results = new Array(this.totalWords).fill(null);
          this.phase2Results = new Array(this.totalWords).fill(null);
          this.phase3Results = new Array(this.totalWords).fill(null);
        } else {
          this.$message.error(response.message || "加载单词失败");
        }
      } catch (error) {
        console.error("加载单词失败:", error);
        this.$message.error("加载单词失败");
      }
    },

    // 获取阶段文本
    getPhaseText() {
      const phaseTexts = {
        'phase1-start': '准备开始第一阶段',
        'phase1': '第一阶段：英文→中文',
        'phase2-start': '准备开始第二阶段',
        'phase2': '第二阶段：中文→英文',
        'phase3-start': '准备开始第三阶段',
        'phase3': '第三阶段：拼写测试',
        'summary': '学习总结'
      };
      return phaseTexts[this.currentPhase] || '';
    },

    // 获取图片完整URL
    getImageUrl(imageUrl, type=0) {
      // 优先使用预加载阶段写入的解析字段
      if (type && this.currentWord && this.currentWord._resolved_image_url) {
        // console.log('[GetImageUrl] 使用预解析URL:', this.currentWord._resolved_image_url);
        return this.currentWord._resolved_image_url;
      }
      if (!imageUrl) {
        return '';
      }
      
      // 如果已经是完整URL，直接返回
      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
      }

      // 拼接API基础URL和图片路径
      const { config } = require('@/config/env');
      let baseUrl = config.VOICE_URL;
      if(!baseUrl) baseUrl = 'https://www.techbvocabulary.com/techb'
      return baseUrl + imageUrl;
    },

    // 处理图片加载错误
    handleImageError(event) {
      console.warn('图片加载失败:', event.target.src);
      // 隐藏整个图片容器
      const imageContainer = event.target.closest('.phase-word-image');
      if (imageContainer) {
        imageContainer.style.display = 'none';
      }
    },

    // 处理图片加载成功
    handleImageLoad(event) {
      console.log('图片加载成功:', event.target.src);
    },

    // 播放发音
    playPronunciation() {
      const pronunciationUrl = this.currentWord.pronunciationUrl || '';
      if (pronunciationUrl) {
        // 使用音频工具函数
        const { playAudio } = require('@/utils/audioUtils');
        playAudio(pronunciationUrl).catch(() => {
          console.error("播放音频失败");
          this.$message.warning("音频播放失败");
        });
      } else {
        this.$message.info("暂无发音文件");
      }
    },

    // 自动播放两次发音（带间隔）
    autoPlayWordTwice() {
      const pronunciationUrl = this.currentWord && this.currentWord.pronunciationUrl;
      if (!pronunciationUrl) {
        console.log('[AutoPlay] 当前单词没有发音URL，跳过自动播放');
        return;
      }
      const { playAudio } = require('@/utils/audioUtils');
      // 第一次播放
      playAudio(pronunciationUrl)
        .then(() => {
          // 设定一个轻微延迟再播第二次，避免音频尚未释放
          setTimeout(() => {
            playAudio(pronunciationUrl).catch(err => {
              console.warn('[AutoPlay] 第二次播放失败', err);
            });
          }, 1000); // 可调节间隔
        })
        .catch(err => {
          console.warn('[AutoPlay] 第一次播放失败', err);
        });
    },

     // 播放背景音乐
    playBackgroundMusic() {
      try {
        if (!this.backgroundMusic) {
          // 创建音频对象
          this.backgroundMusic = new Audio();

          // 尝试加载音频文件
          try {
            this.backgroundMusic.src = require("@/assets/media/bgm_audio.mp3");
          } catch (requireError) {
            // 如果文件不存在，使用静默音频或提示用户
            console.warn("背景音乐文件不存在:", requireError);
            this.$message.warning(
              "请将背景音乐文件 audio.mp3 放置在 src/assets/media/ 目录下"
            );
            this.backgroundMusicPlaying = false;
            return;
          }

          this.backgroundMusic.loop = true; // 循环播放
          this.backgroundMusic.volume = 0.3; // 设置音量为30%

          // 添加错误处理
          this.backgroundMusic.addEventListener("error", (e) => {
            console.error("音频加载失败:", e);
            this.$message.error("背景音乐加载失败，请检查音频文件");
            this.backgroundMusicPlaying = false;
          });

          // 添加加载完成事件
          this.backgroundMusic.addEventListener("canplay", () => {
            console.log("背景音乐加载完成");
          });
        }

        // 播放音乐
        const playPromise = this.backgroundMusic.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              this.backgroundMusicPlaying = true;
              // 移除弹窗提示
              // this.$message.success("背景音乐已开启");
            })
            .catch(() => {
              console.error("播放失败");
              this.$message.warning(
                "播放失败，某些浏览器需要用户先进行交互操作"
              );
              this.backgroundMusicPlaying = false;
            });
        }
      } catch (error) {
        console.error("播放背景音乐失败:", error);
        this.$message.warning(
          "背景音乐功能暂不可用，请确保 audio.mp3 文件存在"
        );
        this.backgroundMusicPlaying = false;
      }
    },

    // 停止背景音乐
    stopBackgroundMusic() {
      if (this.backgroundMusic) {
        this.backgroundMusic.pause();
        this.backgroundMusic.currentTime = 0;
      }
      this.backgroundMusicPlaying = false;
    },

    // 标记为记住
    markAsKnown() {
      this.showMeaning = true;
      this.isRemembered = true;
      
      // 记录结果 - 找到对应的原始单词索引
      const originalIndex = this.findOriginalWordIndex(this.currentWord);
      if (originalIndex !== -1) {
        if (this.currentPhase === 'phase1') {
          this.phase1Results[originalIndex] = true;
        } else if (this.currentPhase === 'phase2') {
          this.phase2Results[originalIndex] = true;
        }
      }
      
      // 记住的单词直接跳过，不需要重复学习
      setTimeout(() => {
        this.nextWord();
      }, 2000);
    },

    // 标记为没记住
    markAsUnknown() {
      this.showMeaning = true;
      this.isRemembered = false;
      
      // 记录结果 - 找到对应的原始单词索引
      const originalIndex = this.findOriginalWordIndex(this.currentWord);
      if (originalIndex !== -1) {
        if (this.currentPhase === 'phase1') {
          this.phase1Results[originalIndex] = false;
        } else if (this.currentPhase === 'phase2') {
          this.phase2Results[originalIndex] = false;
        }
      }
      
      // 没记住的单词需要重复学习，延迟更长时间
      setTimeout(() => {
        this.nextWord();
      }, 3000);
    },

    // 下一个单词
    nextWord() {
      this.showMeaning = false;
      this.userInput = '';
      this.showAnswer = false;
      this.isCorrect = false;
      this.isRemembered = false;
      
      // 检查是否完成了当前阶段的所有单词（包括重新学习的）
      if (this.currentWordIndex < this.totalWords - 1) {
        this.currentWordIndex++;
        this.currentWord = this.words[this.currentWordIndex];
         setTimeout(() => {
          this.autoPlayWordTwice();
        }, 500);
      } else {
        // 当前阶段完成，检查是否有没记住的单词需要重新学习
        this.checkPhaseCompletion();
      }
    },

    // 检查阶段完成情况
    checkPhaseCompletion() {
      // 防止重复调用
      if (this.isReviewingUnknownWords) {
        return;
      }
      
      // 检查是否还有没记住的单词需要重新学习
      const currentPhaseUnknownWords = [];
      
      // 只检查原始单词数量，避免循环检查重新添加的单词
      for (let i = 0; i < this.originalWordCount; i++) {
        const word = this.words[i];
        let isUnknown = false;
        
        if (this.currentPhase === 'phase1') {
          isUnknown = this.phase1Results[i] === false;
        } else if (this.currentPhase === 'phase2') {
          isUnknown = this.phase2Results[i] === false;
        } else if (this.currentPhase === 'phase3') {
          isUnknown = this.phase3Results[i] === false;
        }
        
        if (isUnknown) {
          currentPhaseUnknownWords.push(word);
        }
      }
      
      // 如果有没记住的单词，在当前阶段重新学习
      if (currentPhaseUnknownWords.length > 0) {
        this.reviewUnknownWordsInCurrentPhase(currentPhaseUnknownWords);
      } else {
        // 没有没记住的单词，进入下一阶段
        this.nextPhase();
      }
    },

    // 在当前阶段重新学习没记住的单词
    reviewUnknownWordsInCurrentPhase(unknownWords) {
      // 防止重复调用
      if (this.isReviewingUnknownWords) {
        return;
      }
      
      // 设置标志防止重复调用
      this.isReviewingUnknownWords = true;
      
      if (this.currentPhase === 'phase3') {
        this.$message.warning(`拼写测试有 ${unknownWords.length} 个单词错误，必须重新测试！`);
      } else {
        this.$message.info(`当前阶段有 ${unknownWords.length} 个单词没记住，重新学习...`);
      }
      
      // 将没记住的单词添加到当前单词列表末尾（只添加一次）
      this.words = this.words.concat(unknownWords);
      this.totalWords = this.words.length;
      
      // 重置当前单词索引，从重新学习的单词开始
      this.currentWordIndex = this.originalWordCount;
      this.currentWord = this.words[this.currentWordIndex];
      
      // 重置标志
      this.isReviewingUnknownWords = false;
    },

    // 下一阶段
    nextPhase() {
      if (this.currentPhase === 'phase1') {
        this.currentPhase = 'phase2-start';
        // 重置单词列表为原始列表，准备第二阶段
        this.words = this.words.slice(0, this.originalWordCount);
        this.totalWords = this.originalWordCount;
        this.currentWordIndex = 0;
        this.currentWord = this.words[this.currentWordIndex];
      } else if (this.currentPhase === 'phase2') {
        this.currentPhase = 'phase3-start';
        // 重置单词列表为原始列表，准备第三阶段
        this.words = this.words.slice(0, this.originalWordCount);
        this.totalWords = this.originalWordCount;
        this.currentWordIndex = 0;
        this.currentWord = this.words[this.currentWordIndex];
      } else if (this.currentPhase === 'phase3') {
        this.showSummary();
      }
    },


    // 检查拼写
    checkSpelling() {
      if (!this.userInput.trim()) return;
      
      const userAnswer = this.userInput.trim().toLowerCase();
      const correctAnswer = (this.currentWord.englishWord || this.currentWord.english_word).toLowerCase();
      
      this.isCorrect = userAnswer === correctAnswer;
      this.showAnswer = true;
      
      // 记录结果 - 找到对应的原始单词索引
      const originalIndex = this.findOriginalWordIndex(this.currentWord);
      if (originalIndex !== -1) {
        this.phase3Results[originalIndex] = this.isCorrect;
      }
      
      if (this.isCorrect) {
        // 拼写正确，3秒后进入下一个单词
        setTimeout(() => {
          this.nextWord();
        }, 3000);
      } else {
        // 拼写错误，需要重新输入，5秒后清空输入框重新测试
        setTimeout(() => {
          this.userInput = '';
          this.showAnswer = false;
          this.isCorrect = false;
        }, 5000);
      }
    },

    // 找到对应的原始单词索引
    findOriginalWordIndex(currentWord) {
      for (let i = 0; i < this.originalWordCount; i++) {
        const word = this.words[i];
        if (word.id === currentWord.id || 
            (word.englishWord || word.english_word) === (currentWord.englishWord || currentWord.english_word)) {
          return i;
        }
      }
      return -1;
    },

    // 显示总结
    showSummary() {
      this.currentPhase = 'summary';
      this.studyTime = Math.floor((Date.now() - this.startTime) / 1000); // 秒
      
      // 计算学习结果
      this.calculateResults();
    },

    // 计算学习结果
    calculateResults() {
      this.knownWords = [];
      this.unknownWords = [];
      
      // 只处理原始单词数量
      for (let i = 0; i < this.originalWordCount; i++) {
        const word = this.words[i];
        
        // 综合三个阶段的结果
        const phase1Result = this.phase1Results[i];
        const phase2Result = this.phase2Results[i];
        const phase3Result = this.phase3Results[i];
        
        // 更严格的标准：前两个阶段都必须记住，或者第三阶段正确
        const isKnown = (phase1Result === true && phase2Result === true) || phase3Result === true;
        
        if (isKnown) {
          this.knownWords.push(word);
        } else {
          this.unknownWords.push(word);
        }
      }
      
      // 如果没记住的单词太多，给出建议
      if (this.unknownWords.length > this.totalWords * 0.5) {
        this.$message.warning(`有 ${this.unknownWords.length} 个单词没记住，建议重新学习！`);
      }
    },

    // 重新学习没记住的单词
    reviewUnknownWords() {
      if (this.unknownWords.length === 0) {
        this.$message.info("没有需要重新学习的单词");
        return;
      }
      
      // 重置为没记住的单词列表
      this.words = this.unknownWords;
      this.totalWords = this.words.length;
      this.currentWordIndex = 0;
      this.currentWord = this.words[0];
      
      // 重置结果数组
      this.phase1Results = new Array(this.totalWords).fill(null);
      this.phase2Results = new Array(this.totalWords).fill(null);
      this.phase3Results = new Array(this.totalWords).fill(null);
      
      // 重新开始第一阶段
      this.currentPhase = 'phase1-start';
      
      this.$message.success(`开始重新学习 ${this.totalWords} 个没记住的单词`);
    },

    // 完成学习
    async finishLearning() {
      try {
        // 准备学习结果数据 - 只处理原始单词
        const learningResults = [];
        
        for (let i = 0; i < this.originalWordCount; i++) {
          const word = this.words[i];
          const phase1Result = this.phase1Results[i];
          const phase2Result = this.phase2Results[i];
          const phase3Result = this.phase3Results[i];
          
          // 综合判断是否掌握
          const isMastered = (phase1Result === true && phase2Result === true) || phase3Result === true;
          
          // 确保word_id是数字类型
          if (word && word.id) {
            learningResults.push({
              word_id: parseInt(word.id),
              is_correct: isMastered ? 1 : 0
            });
          }
        }
        
        // console.log('提交的学习结果:', learningResults);
        
        // 提交学习结果
        const response = await CourseAPI.submitUnitLearning(
          this.unit.id,
          learningResults,
          this.studyTime,
          new Date().toISOString().split('T')[0]
        );
        
        if (response && response.success) {
          const result = response.data;
          this.$emit('learning-completed', result);
          this.dialogVisible = false;
        } else {
          this.$message.error(response.message || "提交学习结果失败");
        }
      } catch (error) {
        console.error("提交学习结果失败:", error);
        this.$message.error("提交学习结果失败");
      }
    },

    // 处理关闭
    handleClose() {
      if (this.currentPhase !== 'summary' && this.currentWordIndex > 0) {
        this.$confirm('确定要关闭吗？当前学习进度将不会保存。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           // 停止背景音乐
          this.stopBackgroundMusic();
          this.dialogVisible = false;
        }).catch(() => {
          // 取消关闭
        });
      } else {
          // 停止背景音乐
          this.stopBackgroundMusic();
        this.dialogVisible = false;
      }
    },

    // 预加载图片工具函数
    preloadImages(words) {
      if (!words || !Array.isArray(words)) return Promise.resolve([]);
      const imagePromises = words
        .filter(word => word.imageUrl)
        .map(word => {
          return new Promise((resolve) => {
            const img = new window.Image();
            const imageUrl = this.getImageUrl(word.imageUrl);
            // console.log(`开始预加载图片地址: ${imageUrl}`);
            // 预先写入解析后的完整URL，组件可直接使用
            word._resolved_image_url = imageUrl;
            img.onload = () => {
              word._image_preloaded = true;
              // console.log(`✅ 预加载成功: ${word.englishWord} - ${imageUrl}`);
              resolve({ word: word.englishWord || word.english_word, success: true, url: imageUrl });
            };
            img.onerror = () => {
              word._image_preloaded = false;
              // console.warn(`❌ 预加载失败: ${word.englishWord} - ${imageUrl}`);
              resolve({ word: word.englishWord || word.english_word, success: false, url: imageUrl });
            };
            setTimeout(() => {
              if (!img.complete) {
                word._image_preloaded = false;
                resolve({ word: word.englishWord || word.english_word, success: false, url: imageUrl, timeout: true });
              }
            }, 5000);
            img.src = imageUrl;
          });
        });
      return Promise.all(imagePromises);
    }
  }
};
</script>

<style scoped>
.unit-learning-dialog .el-dialog__body {
  padding: 20px;
  overflow-y: auto;
}

.dialog-content {
  min-height:450px;
  height: 100%;
  text-align: center;
}

.learning-progress {
  margin-bottom: 24px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.current-phase {
  font-weight: 600;
  color: #409EFF;
}

.phase-start {
  min-height: 410px;
  height: 90%;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.start-content h2 {
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 16px;
}

.start-content p {
  font-size: 16px;
  color: #7f8c8d;
  margin-bottom: 12px;
  line-height: 1.6;
}

.start-content .el-button {
  margin: 8px;
}

.phase-content {
  text-align: center;
}

.word-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  height: 410px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.word-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.phase-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.skip-button {
  color: #909399;
}

.word-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.phase-word-top{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

/* 图片区域 - 绝对定位在左侧红框位置 */
.phase-word-image {
  width: 200px;
  height: 150px;
}

.phase-word-img {
  max-width: 200px;
  max-height: 150px;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}

.word-main {
  margin-bottom: 24px;
  /* width: 63%; */
}

.english-word {
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.chinese-meaning {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.word-phonetic {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin: 10px 0;
}

.phonetic-item {
  font-size: 16px;
  color: #7f8c8d;
  font-style: italic;
  padding: 4px 8px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #f8f9fa;
}

.word-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 20px;
}

.spelling-input {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 20px;
}

.spelling-input .el-input {
  width: 300px;
}

.word-meaning {
  background: white;
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid #409EFF;
}

.result-feedback {
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  text-align: center;
}

.result-feedback.remembered {
  background: #f0f9ff;
  border: 1px solid #67C23A;
  color: #67C23A;
}

.result-feedback.correct {
  background: #f0f9ff;
  border: 1px solid #67C23A;
  color: #67C23A;
}

.result-feedback.incorrect {
  background: #fef0f0;
  border: 1px solid #F56C6C;
  color: #F56C6C;
}

.feedback-text {
  margin: 0;
  font-weight: 600;
  font-size: 14px;
}

.example-sentence {
  font-size: 14px;
  color: #7f8c8d;
  line-height: 1.4;
  margin-top: 8px;
}

.correct {
  color: #67C23A;
}

.incorrect {
  color: #F56C6C;
}

.learning-summary {
  text-align: center;
  padding: 40px 20px;
}

.summary-header h3 {
  font-size: 24px;
  color: #2c3e50;
  margin-bottom: 8px;
}

.summary-header p {
  color: #7f8c8d;
  margin-bottom: 32px;
}

.summary-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 32px;
}

.stat-item {
  text-align: center;
}

.stat-label {
  display: block;
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 4px;
}

.stat-value {
  display: block;
  font-size: 24px;
  font-weight: 600;
  color: #409EFF;
}

.stat-value.known {
  color: #67C23A;
}

.stat-value.unknown {
  color: #F56C6C;
}

.stat-value.excellent {
  color: #67C23A;
  font-weight: 700;
}

.stat-value.good {
  color: #E6A23C;
  font-weight: 600;
}

.stat-value.poor {
  color: #F56C6C;
  font-weight: 700;
}

.learning-quality {
  margin-bottom: 24px;
}

.quality-warning {
  background: #fef0f0;
  border: 1px solid #F56C6C;
  border-radius: 8px;
  padding: 12px 16px;
  color: #F56C6C;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.quality-warning i {
  font-size: 16px;
}

.summary-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

/* 响应式设计 */
/* 平板适配：600px - 1024px */
@media (min-width: 600px) and (max-width: 1024px) {
  ::v-deep .unit-learning-dialog .el-dialog__body {
    min-height: 540px;
    height: auto;
  }
  
  .word-card{
    min-height: 410px;
    height: auto;
  }

  .phase-start {
    min-height: 410px;
  }

  .summary-stats {
    flex-direction: column;
    gap: 20px;
  }
  
  .summary-actions {
    flex-direction: column;
  }
  
  .spelling-input {
    flex-direction: column;
  }
  
  .spelling-input .el-input {
    width: 100%;
  }
}

</style>

<!-- 非 scoped 全局样式：覆盖 Element UI append-to-body 场景 -->
<style>

.unit-learning-dialog .el-dialog{
  width: 65% !important;
  max-width: 800px !important;
}
</style>